// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2dFQw","checkboxCol":"Table_checkboxCol__3Ys1H","emailCol":"Table_emailCol__3GeMg","actionCol":"Table_actionCol__JKQoG"};